import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import navbarReducer from '../features/navmenu/navbarSlice';
import healthReducer from '../features/health/healthSlice';
import profileReducer from '../features/profile/profileSlice';
import customersReducer from '../features/customers/customersSlice';
import noteReducer from '../features/note/noteSlice';

export const store = configureStore({
  reducer: {
    navbar: navbarReducer,
    health: healthReducer,
    profile: profileReducer,
    customers: customersReducer,
    note: noteReducer
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
